import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18nData from './i18nData'

Vue.use(VueI18n)

const LOCALE_KEY = 'smartinvoice_locale'

function getSavedLocale() {
  const saved = localStorage.getItem(LOCALE_KEY)
  const supportedLocales = Object.keys(i18nData)
  if (saved && supportedLocales.includes(saved)) {
    return saved
  }
  return 'en'
}

const i18n = new VueI18n({
  locale: getSavedLocale(),
  fallbackLocale: 'en',
  messages: i18nData
})

export function setLocale(locale) {
  i18n.locale = locale
  localStorage.setItem(LOCALE_KEY, locale)
}

export default i18n
